// src/App.tsx
import 'regenerator-runtime/runtime'
import { useMemo } from 'react'
import { Provider } from 'react-redux'

import { WidgetContainer } from './components/widgets/WidgetContainer'
import type { LibConfig } from './types/lib-config'
import { DEFAULT_BASE_API_URL } from './types/lib-config'

import { createAgentApiSlice } from './store/service/agentApiSlice'
import { createChatApiSlice } from './store/service/chatApiSlice'
import { createModeApiSlice } from './store/service/modeApiSlice'
import { createDynamicStore } from './store/store'

export default function App({ config }: { config: LibConfig }) {
  const baseApiUrl = useMemo(() => {
    const v = typeof config.baseApiUrl === 'string' ? config.baseApiUrl.trim() : ''
    return v.length > 0 ? v : DEFAULT_BASE_API_URL
  }, [config.baseApiUrl])

  const agentApi = useMemo(() => createAgentApiSlice(baseApiUrl), [baseApiUrl])
  const chatApi = useMemo(() => createChatApiSlice(baseApiUrl), [baseApiUrl])
  const modeApi = useMemo(() => createModeApiSlice(baseApiUrl), [baseApiUrl])

  const store = useMemo(
    () => createDynamicStore(chatApi, agentApi, modeApi),
    [chatApi, agentApi, modeApi]
  )

  return (
    <Provider store={store}>
      <WidgetContainer
        config={config}
        agentApi={agentApi}
        chatApi={chatApi}
        modeApi={modeApi}
      />
    </Provider>
  )
}
